import { Common } from "../actionTypes/common";

export const sendMail = (payload) => ({
  type: Common.SEND_EMAIL,
  payload,
});